import { api } from './api'
import type {
  ConnectivityGraph,
  ConnectivitySPOF,
  BandwidthAnalysis,
  OptimizeResult,
  ConnDevice,
  CableConnection,
} from '../types'

const DC_PREFIX = '/api/datacenters'

export async function fetchConnectivityGraph(dcCode: string, workspace: string = 'master'): Promise<ConnectivityGraph> {
  const { data } = await api.get(`${DC_PREFIX}/${dcCode}/connectivity/graph`, {
    params: { workspace }
  })
  return data as ConnectivityGraph
}

export async function fetchSpofAnalysis(dcCode: string, workspace: string = 'master'): Promise<ConnectivitySPOF> {
  const { data } = await api.get(`${DC_PREFIX}/${dcCode}/connectivity/spof`, {
    params: { workspace }
  })
  return data as ConnectivitySPOF
}

export async function fetchBandwidthAnalysis(dcCode: string, workspace: string = 'master'): Promise<BandwidthAnalysis> {
  const { data } = await api.get(`${DC_PREFIX}/${dcCode}/connectivity/bandwidth`, {
    params: { workspace }
  })
  return data as BandwidthAnalysis
}

export async function fetchOptimize(
  dcCode: string,
  deviceIdA: string,
  deviceIdB: string,
): Promise<OptimizeResult> {
  const { data } = await api.post(`${DC_PREFIX}/${dcCode}/connectivity/optimize`, {
    source_device_id: deviceIdA,
    target_device_id: deviceIdB,
  })
  return data as OptimizeResult
}

export async function fetchDevices(dcCode: string): Promise<ConnDevice[]> {
  const graph = await fetchConnectivityGraph(dcCode)
  return graph.devices
}

export async function createCable(
  dcCode: string,
  payload: {
    port_a_id: string
    port_b_id: string
    cable_type?: string
    color?: string
    length_m?: number
    tia_606_tag?: string
  },
  workspace: string = 'master'
): Promise<CableConnection> {
  const { data } = await api.post(`${DC_PREFIX}/${dcCode}/connectivity/cables`, payload, {
    params: { workspace }
  })
  return data as CableConnection
}

export async function updateCable(
  dcCode: string,
  cableId: string,
  payload: Partial<Pick<CableConnection, 'cable_type' | 'color' | 'length_m' | 'tia_606_tag'>>,
): Promise<CableConnection> {
  const { data } = await api.patch(
    `${DC_PREFIX}/${dcCode}/connectivity/cables/${cableId}`,
    payload,
  )
  return data as CableConnection
}

export async function deleteCable(dcCode: string, cableId: string, workspace: string = 'master'): Promise<void> {
  await api.delete(`${DC_PREFIX}/${dcCode}/connectivity/cables/${cableId}`, {
    params: { workspace }
  })
}
